import type { TimelineItem } from '../../types';
import { compactTime } from '../../lib/time';

export function Timeline({ items, revealPending, onTogglePending, onComplete }: {
  items: TimelineItem[]; revealPending: boolean; onTogglePending(): void; onComplete(id: number): void;
}) {
  const pending = items.filter((item) => item.state === 'pending_reflection');
  const visible = items.filter((item) => item.state !== 'pending_reflection' || revealPending);
  return <main className="timeline" aria-live="polite">
    {pending.length > 0 && <button className="reflection-notice" onClick={onTogglePending}>
      <span>{pending.length}</span> {pending.length === 1 ? 'мысль ожидает тишины' : 'мысли ожидают тишины'}
    </button>}
    <div className="timeline-rail" />
    {visible.length === 0 ? <div className="empty-state"><p>Здесь пока тихо.</p><em>Мысль можно оставить внизу — остальное подождёт.</em></div> : visible.map((item) =>
      <article key={`${item.source}-${item.id}`} className={`thought-card is-${item.state}`} onClick={() => item.state === 'active' && onComplete(item.id)}>
        <time>{compactTime(item.createdAt)}</time>
        {item.attachment && <div className="document-badge"><span aria-hidden="true">▤</span>{item.attachment.name}</div>}
        <p>{item.text}</p>
        <span>{item.state === 'pending_reflection' ? 'на обдумывании' : item.state === 'completed' ? 'прожито' : item.source === 'voice' ? 'голос' : 'мысль'}</span>
      </article>)}
  </main>;
}
